import { useState, useEffect, useRef } from "react";
import api from "@/api";
import { Input } from "@/components/ui/input";

const COUNTRY_FLAGS = {
  "Portugal": "🇵🇹", "Espanha": "🇪🇸", "França": "🇫🇷", "Suíça": "🇨🇭", "Luxemburgo": "🇱🇺",
  "Reino Unido": "🇬🇧", "Alemanha": "🇩🇪", "Itália": "🇮🇹", "Bélgica": "🇧🇪", "Países Baixos": "🇳🇱",
  "Andorra": "🇦🇩",
};

export const AutocompleteInput = ({ value, onChange, placeholder, testid, className = "", inputClassName = "h-12 rounded-xl", icon }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    if (!value || value.trim().length < 2) {
      setSuggestions([]);
      setOpen(false);
      return;
    }
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        const { data } = await api.get("/cities", { params: { q: value } });
        setSuggestions(data);
        setOpen(data.length > 0);
      } catch {
        setSuggestions([]);
      }
    }, 200);
    return () => clearTimeout(timer.current);
  }, [value]);

  return (
    <div className={`relative ${className}`} data-testid={`${testid}-wrapper`}>
      {icon}
      <Input
        data-testid={testid}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => suggestions.length > 0 && setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
        className={inputClassName}
        autoComplete="off"
      />
      {open && (
        <ul className="absolute z-30 left-0 right-0 mt-1.5 bg-white border border-slate-200 rounded-xl shadow-[0_12px_40px_rgba(15,41,66,0.14)] overflow-hidden" data-testid={`${testid}-suggestions`}>
          {suggestions.map((s, i) => (
            <li key={s.name}>
              <button
                type="button"
                data-testid={`${testid}-option-${i}`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange(s.name);
                  setOpen(false);
                }}
                className="w-full text-left px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 transition-colors duration-100"
              >
                {s.name}
                {s.country && <span className="text-xs text-slate-400 ml-1.5">{COUNTRY_FLAGS[s.country] || ""} {s.country}</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
